"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcOffCanvasBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_off_canvas_constants_1 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_2 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_3 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_4 = require("./bc-off-canvas-constants");
var helpers_1 = require("../../../common/helpers");
var BcOffCanvasBehavior = (function (_super) {
    __extends(BcOffCanvasBehavior, _super);
    function BcOffCanvasBehavior() {
        return _super.call(this) || this;
    }
    BcOffCanvasBehavior.setUpAll = function () {
        var offCanvasElements = Array.from(document.querySelectorAll("section[class~='".concat(bc_off_canvas_constants_2.OFF_CANVAS, "']")));
        var elements = [];
        for (var _i = 0, offCanvasElements_1 = offCanvasElements; _i < offCanvasElements_1.length; _i++) {
            var offCanvasElement = offCanvasElements_1[_i];
            var element = offCanvasElement;
            var bc = new BcOffCanvasBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcOffCanvasBehavior.prototype._setUp = function () {
        this.configCloseButton();
        this.closeAccesibilidad();
        this.closeOffCanvasWithclick();
        this.closeEventKey();
    };
    BcOffCanvasBehavior.prototype.closeOffCanvasWithclick = function () {
        var _this = this;
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (event.target.className === bc_off_canvas_constants_2.OFF_CANVAS) {
                _this.close();
            }
        });
    };
    BcOffCanvasBehavior.prototype.closeEventKey = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.close();
            }
        });
    };
    BcOffCanvasBehavior.prototype.open = function () {
        this.changeStatus(bc_off_canvas_constants_1.OffCanvasStatus.open);
    };
    BcOffCanvasBehavior.prototype.close = function () {
        this.changeStatus(bc_off_canvas_constants_1.OffCanvasStatus.close);
    };
    BcOffCanvasBehavior.prototype.configCloseButton = function () {
        var _this = this;
        var closeButton = this.mySelf.querySelector("".concat(bc_off_canvas_constants_3.OFF_CANVAS_BUTTONS_QUERY));
        closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.close();
        });
    };
    BcOffCanvasBehavior.prototype.closeAccesibilidad = function () {
        var closeButton = this.mySelf.querySelector("".concat(bc_off_canvas_constants_3.OFF_CANVAS_BUTTONS_QUERY));
        (0, helpers_1.addFocusable)(closeButton, { tabindex: '0' });
    };
    BcOffCanvasBehavior.prototype.changeStatus = function (status) {
        this.mySelf.setAttribute(bc_off_canvas_constants_4.OFF_CANVAS_STATUS_PROPERTY, status);
    };
    return BcOffCanvasBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcOffCanvasBehavior = BcOffCanvasBehavior;
